import { render } from "./WeaponAbilityCompendiumModal.vue?vue&type=template&id=71ace5a2"
import script from "./WeaponAbilityCompendiumModal.vue?vue&type=script&lang=js"
export * from "./WeaponAbilityCompendiumModal.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__